import React, { useState, useEffect } from 'react';
import { getCatWithoutNotesApi } from '../api/category';
import ShowHome from '../components/Web/Home/ShowHome';

export default function Home(props) {
    const { history, location } = props;
    const [ categories, setCategories ] = useState([]);
    const [ reloadCategories, setReloadCategories ] = useState(false);

    useEffect(() => {
        getCatWithoutNotesApi().then(response => {
            setCategories(response.category);
        });

        setReloadCategories(false);
    }, [reloadCategories]);

    return (
        <div>
            <ShowHome 
                categories={categories}
                setReloadCategories={setReloadCategories}
                history={history}
                location={location}
            />
        </div>
        
    )
}